
import Vue from 'vue';
import { StageStartingPriceMethod } from './StagePrice.enums';
import { initializeStore } from '@seamless/store';
import { connectionName, isWithinVehicleContext } from '@dh-io-mbmxp/vehicle-data-store-connection';
import { StagePriceComputed, StagePriceData, StagePriceMethods, StagePriceProps } from './StagePrice';

export default Vue.extend<StagePriceData, StagePriceMethods, StagePriceComputed, StagePriceProps>({
  name: 'owc-stage-price',
  props: {
    priceData: {
      type: Object,
      required: true,
    },
    vehicleData: {
      type: Object,
      required: false,
    },
  },
  computed: {
    isAutomaticStartingPrice() {
      return this.priceData.startingPriceMethod === StageStartingPriceMethod.Automated;
    },
  },
  data() {
    return {
      market: '',
      language: '',
      price: null,
    };
  },
  async mounted() {
    await this.setPrice();
  },
  methods: {
    async setPrice() {
      if (this.isAutomaticStartingPrice) {
        if (await isWithinVehicleContext()) {
          this.setPriceFromStore();
        } else {
          await this.setPriceFromService();
        }
      } else {
        this.setPriceFromProps();
      }
    },
    setPriceFromStore() {
      const store = initializeStore();
      store.subscribe(connectionName, state => {
        this.price = this.mapToPriceInformations(state.price);
      });
    },
    async setPriceFromService() {
      if (this.vehicleData?.modelSeries) {
        const { modelSeries, subBrands, engineConcept } = this.vehicleData;
        const { loadPriceData } = await import('@dh-io-mbmxp/vehicle-context-automation');
        const configuration = await loadPriceData(modelSeries, engineConcept, subBrands);
        if (configuration) {
          this.price = this.mapToPriceInformations(configuration);
        }
      }
    },
    setPriceFromProps() {
      this.price = this.priceData;
    },
    mapToPriceInformations(priceData) {
      return {
        ...this.priceData,
        priceWithCurrency: priceData.min,
        pricePrefix: priceData.pricePrefixLabel,
        tooltip: {
          ...this.priceData.tooltip,
          text: priceData?.priceFootnoteLabel || '',
        },
      };
    },
  },
});
